namespace SPA
{
	export namespace Organization
	{
		export namespace gui
		{
			export class NewCompanyEntry extends AbstractEntry
			{

				public constructor( orga: OrgaTree )
				{
					super( orga );

					this.clearTitle();
				}

				public rebuild( root?: ui.base.BaseHTMLElement<HTMLElement> | JQuery<HTMLElement> ): NewCompanyEntry
				{
					super.rebuild( root );

					return this;
				}
			}
		}
	}
}
